export default {
  //授课作业列表
  SKHomeWorkList: '',
  //授课作业完成学生
  SKHomeWorkStuCount: '',
  //授课作业未完成学生
  SKHomeWorkStuList: '',
  //作业详情
  SKHomeWorkDetails: '',
  //作业测试列表
  SKHomeWorkTestList: '',
  //作业完成情况
  SKHomeWorkStuMessage: '',
  //授课作业编辑
  SKHomeWorkEdit: '',
}
